import React from 'react';
import Icon from '../../../components/AppIcon';

const ComparisonSection = () => {
  const comparisonData = [
  {
    metric: "Verfügbarkeit",
    advocall: "24/7",
    industry: "Mo-Fr 9-17h",
    advantage: "Rund um die Uhr",
    icon: "Phone",
    color: "text-trust-builder"
  },
  {
    metric: "Transparente Preise",
    advocall: "2,99 €/Min",
    industry: "150-400 €/h",
    advantage: "Volle Kostenkontrolle",
    icon: "Euro",
    color: "text-primary"
  },
  {
    metric: "Erreichbarkeit",
    advocall: "Telefonisch von überall",
    industry: "Persönlicher Termin",
    advantage: "Keine Anfahrt nötig",
    icon: "MapPin",
    color: "text-accent"
  },
  {
    metric: "Terminvereinbarung",
    advocall: "Sofort anrufen",
    industry: "Terminvereinbarung erforderlich",
    advantage: "Keine Wartezeit auf Termin",
    icon: "Calendar",
    color: "text-conversion-accent"
  }];


  const performanceIndicators = [
  {
    category: "Reaktionszeit",
    advocall: "Sofort",
    traditional: "Terminvereinbarung erforderlich",
    benefit: "Keine Verzögerung bei dringenden Rechtsfragen"
  },
  {
    category: "Kostenstruktur",
    advocall: "Minutengenau abgerechnet",
    traditional: "Stundensätze ab 150 €",
    benefit: "Bezahlen Sie nur für die tatsächlich benötigte Zeit"
  },
  {
    category: "Zugänglichkeit",
    advocall: "Telefonisch von überall",
    traditional: "Persönlicher Termin in der Kanzlei",
    benefit: "Rechtshilfe ohne Anfahrt und Wartezeiten"
  },
  {
    category: "Spezialisierung",
    advocall: "Alle Rechtsgebiete verfügbar",
    traditional: "Oft auf wenige Bereiche beschränkt",
    benefit: "Kompetente Beratung in allen Rechtsfragen"
  }];


  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-text-primary mb-4">
            AdvoCall vs. Traditionelle Rechtsberatung
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Ein Vergleich zeigt unsere strukturellen Vorteile gegenüber herkömmlichen Anwaltskanzleien.
          </p>
        </div>

        {/* Performance Metrics Comparison */}
        <div className="mb-16">
          <h3 className="text-2xl font-semibold text-text-primary mb-8 text-center">
            Leistungsmerkmale im Vergleich
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
            {comparisonData?.map((item, index) =>
            <div
              key={index}
              className="bg-white border border-slate-200 rounded-xl p-6 shadow-professional hover:shadow-elevated transition-all duration-300">

                <div className="flex items-center mb-4">
                  <div className={`p-3 rounded-lg bg-opacity-10 ${item?.color?.replace('text-', 'bg-')}`}>
                    <Icon name={item?.icon} size={24} className={item?.color} />
                  </div>
                  <h4 className="font-semibold text-text-primary ml-3">
                    {item?.metric}
                  </h4>
                </div>

                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-text-secondary">AdvoCall:</span>
                    <span className={`font-bold ${item?.color}`}>
                      {item?.advocall}
                    </span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-text-secondary">Traditionelle Kanzlei:</span>
                    <span className="font-medium text-text-secondary">
                      {item?.industry}
                    </span>
                  </div>
                  <div className="pt-2 border-t border-slate-100">
                    <div className="flex items-center space-x-2">
                      <Icon name="CheckCircle" size={16} className="text-trust-builder" />
                      <span className="text-sm font-medium text-trust-builder">
                        {item?.advantage}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Detailed Comparison Table */}
        <div className="mb-16">
          <h3 className="text-2xl font-semibold text-text-primary mb-8 text-center">
            Detaillierter Servicevergleich
          </h3>
          <div className="bg-white rounded-xl shadow-professional border border-slate-200 overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gradient-to-r from-primary to-accent text-white">
                  <tr>
                    <th className="px-6 py-4 text-left font-semibold">Kategorie</th>
                    <th className="px-6 py-4 text-left font-semibold">AdvoCall</th>
                    <th className="px-6 py-4 text-left font-semibold">Traditionelle Kanzlei</th>
                    <th className="px-6 py-4 text-left font-semibold">Ihr Vorteil</th>
                  </tr>
                </thead>
                <tbody>
                  {performanceIndicators?.map((item, index) =>
                  <tr
                    key={index}
                    className={`${index % 2 === 0 ? 'bg-muted' : 'bg-white'} hover:bg-slate-50 transition-colors duration-200`}>

                      <td className="px-6 py-4 font-medium text-text-primary">
                        {item?.category}
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center space-x-2">
                          <Icon name="CheckCircle" size={16} className="text-trust-builder" />
                          <span className="text-trust-builder font-medium">
                            {item?.advocall}
                          </span>
                        </div>
                      </td>
                      <td className="px-6 py-4 text-text-secondary">
                        {item?.traditional}
                      </td>
                      <td className="px-6 py-4 text-text-secondary text-sm">
                        {item?.benefit}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Key Advantages */}
        <div className="bg-gradient-to-r from-muted to-white rounded-xl p-8">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-semibold text-text-primary mb-4">Unsere Stärken</h3>
            <p className="text-text-secondary max-w-2xl mx-auto">Was AdvoCall von traditionellen Kanzleien unterscheidet.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-primary bg-opacity-10 rounded-full mb-4">
                <Icon name="Phone" size={32} className="text-primary" />
              </div>
              <h4 className="font-semibold text-text-primary mb-2">Sofortige Erreichbarkeit</h4>
              <p className="text-text-secondary text-sm">24/7 telefonisch verfügbar – ohne Terminvereinbarung</p>
            </div>

            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-conversion-accent bg-opacity-10 rounded-full mb-4">
                <Icon name="Euro" size={32} className="text-conversion-accent" />
              </div>
              <h4 className="font-semibold text-text-primary mb-2">Transparente Kosten</h4>
              <p className="text-text-secondary text-sm">2,99 €/Min – minutengenau, keine versteckten Gebühren</p>
            </div>

            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-trust-builder bg-opacity-10 rounded-full mb-4">
                <Icon name="Scale" size={32} className="text-trust-builder" />
              </div>
              <h4 className="font-semibold text-text-primary mb-2">Zugelassene Anwälte</h4>
              <p className="text-text-secondary text-sm">Alle Berater sind bei der Rechtsanwaltskammer zugelassen</p>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default ComparisonSection;